import { sanitizeUrl } from './sanitize-url'

export function safe(string) {
  return string || ''
}

export function urlSafe(urlString) {
  urlString = urlString || ''
  return encodeURIComponent(
    urlString
      .replace(/\./g, '')
      // eslint-disable-next-line no-useless-escape
      .replace(/\,/g, '')
      // eslint-disable-next-line no-useless-escape
      .replace(/\:/g, '')
      // eslint-disable-next-line no-useless-escape
      .replace(/\"/g, '')
      .replace(/’/g, '')
      .replace(/“/g, '')
      .replace(/”/g, '')
      .replace(/\?/g, '')
      .replace(/&/g, '')
      .replace(/—/g, '')
      .replace(/\//g, '')
      .replace(/ - /g, '-')
      .replace(/[\s-]+/g, '-')
  )
}

export function logSafe(string) {
  return string.replace('\n', '_').replace('\r', '_')
}

export function safeLabel(value, label) {
  if (value && value !== '-') {
    return value + label
  } else {
    return '-'
  }
}

export function formatDate(dateStr, fullMonthName, includeDate) {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  if (dateStr && dateStr !== '-') {
    if (fullMonthName) {
      // Due to the timezone change, getMonth and getFullYear values can also change, so use UTC to keep it consistent.
      const date = new Date(dateStr)

      if (includeDate) {
        return [
          monthNames[date.getUTCMonth()],
          date.getUTCDate() + ',',
          date.getUTCFullYear(),
        ].join(' ')
      }

      return [monthNames[date.getUTCMonth()], date.getUTCFullYear()].join(' ')
    }

    // Note: given a yyyy-mm-dd format, return a MM/DD/YYYY display.
    const values = dateStr.split('-')

    return [values[1], values[2], values[0]].join('/')
  }

  return '-'
}

export function convertStringsToNumbers(list) {
  const regex = /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:(\.|,)\d+)?$/
  const results = []

  list.forEach((value) => {
    let match = null

    if (typeof value === 'string') {
      // if it's a blank or a dash, handle it as a minimum value.
      if (!value || value === '-') {
        results.push(Number.MIN_SAFE_INTEGER)
        return
      }

      match = value.match(regex)
      if (match && match.length > 0) {
        const num = parseFloat(match[0].replace(/,/g, ''))
        results.push(num)
      }
    } else {
      results.push(value)
    }
  })

  return results.length > 0 ? results : list
}

export function addToUrl(base, query) {
  if (!query) {
    return base
  }
  if (base.indexOf('?') >= 0) {
    return base + '&' + query
  } else {
    return base + '?' + query
  }
}

export function encodeForURL(input) {
  return input ? encodeURI(sanitizeUrl(input)) : null
}

export function formatDateStandard(isoDate) {
  if (isoDate === '-') {
    return isoDate
  } else if (isoDate) {
    try {
      const isoSplit = isoDate.split('T')
      if (isoSplit.length > 1) {
        const dateArray = isoSplit[0].split('-')
        const newDate = new Date(
          dateArray[0],
          new Number(dateArray[1] - 1),
          dateArray[2]
        )
        return new Intl.DateTimeFormat('en-US').format(newDate)
      } else {
        return isoDate
      }
    } catch (error) {
      return isoDate
    }
  } else {
    return isoDate
  }
}
